/**
 * SHER-1128 (SHER-308 Phase 4) — the Billing CSV interchange primitives.
 *
 * Billing's price-lists.csv / assignments.csv are a data-interchange format the screen both
 * emits AND re-imports through its own parser (the first line is the header row), so they
 * deliberately do NOT go through src/utils/csvDownload's human-facing builder: a UTF-8 BOM or
 * CRLF would ride into the first header name and break the round-trip (see that file's note).
 * These two hand-rolled primitives are that format's cell codec, shared by the price and
 * assignment codecs so the rule lives once.
 */

/** Split a CSV line into trimmed cells, honouring quoted fields and "" escapes. */
export function parseCsvLine(line: string): string[] {
    const result: string[] = [];
    let current = '';
    let inQuotes = false;
    for (let i = 0; i < line.length; i++) {
        const char = line[i];
        if (char === '"') {
            if (inQuotes && line[i + 1] === '"') { current += '"'; i++; }
            else { inQuotes = !inQuotes; }
        } else if (char === ',' && !inQuotes) {
            result.push(current); current = '';
        } else {
            current += char;
        }
    }
    result.push(current);
    return result.map(v => v.trim());
}

/** Quote a cell that contains a comma, quote or newline; otherwise return it unchanged. */
export function escapeCsvField(value: string): string {
    return /[",\n]/.test(value) ? `"${value.replace(/"/g, '""')}"` : value;
}
